import React from 'react'

import { connect } from "react-redux"

//import BlankBanner from '../assets/Blank page banner.png'
import Banner from '../assets/Candidate_header.PNG'
import BcrBanner from '../assets/BCR Banner Without Logo.png'
import BannerStripes from '../assets/header stripes.png'
import SaGovLogo from '../assets/SAGovLogo.png'
import BcrBannerRightAlign from '../assets/BCR Banner_RightAlign.png'

import * as actionCreators from "../actionCreators/app.js"

import '../css/header.css'

const Header = ({ toggleMenu }) => {
  return (
    <div className="header-banner" id="header">
       <button className="menu-icon pi pi-bars" aria-label="Menu" aria-expanded="false" onClick={toggleMenu}></button>
        <img src={BcrBannerRightAlign} alt={'Government of South Australia: BoardingCall - logo'} className={"full-banner-image"} />
      </div> 

  )
}

const mapStateToProps = (state) => {
  return {}
}

export default connect(mapStateToProps, actionCreators)(Header)



// WEBPACK FOOTER //
// ./src/container/Header.js